import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DoctorSocialRoutingModule } from './doctor-social-routing.module';
import { DoctorSocialComponent } from './doctor-social.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SidemenuDocModule } from '../sidemenu/sidemenu-doc.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { InterestDialogComponent } from './interest-dialog/interest-dialog.component';
import { PostFeedDialogComponent } from './post-feed-dialog/post-feed-dialog.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { StoryDetailsDialogComponent } from './story-details-dialog/story-details-dialog.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { SideMenuPatientModule } from 'src/app/patients/sidemenu/side-menu-patient.module';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MySocialActivityComponent } from '../my-social-activity/my-social-activity.component';
import { SharedSocialComps } from './shared-social-com/shared-social.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { ContributorModule } from 'src/app/contributor/contributor.module';
import { SideBarNotLoggedComponent } from './side-bar-not-logged/side-bar-not-logged.component';
import { PostDetailsComComponent } from './post-details-com/post-details-com.component';
import { SocialManagerModule } from 'src/app/social-manager/social-manager.module';


@NgModule({
  declarations: [DoctorSocialComponent,MySocialActivityComponent,InterestDialogComponent,PostFeedDialogComponent, StoryDetailsDialogComponent,SideBarNotLoggedComponent, PostDetailsComComponent ],
  imports: [
    CommonModule,
    DoctorSocialRoutingModule,
    SharedModule,
    SidemenuDocModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    SharedSocialComps,
    MatIconModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatProgressBarModule,
    SlickCarouselModule,
    SideMenuPatientModule,
    ContributorModule,
    SocialManagerModule,
    ClipboardModule
  ]
})
export class DoctorSocialModule { }
